import Header from "@/components/Header/components";
import FormsMixin from "@/mixins/FormsMixin";
import { CLIENTES } from "@/store/modules/SeleccionCliente/types";
import { ARTICULO, ARTICULO_WEB, CATEGORIAS, CESTA } from "@/store/modules/ventas/types";
import { Component } from "vue-property-decorator";
import { Action, State } from "vuex-class";
import Template from "./template.vue";
import { PROVEED } from "@/store/modules/Proveedores/types";

// ARTICULOS

@Component({
  mixins: [Template],
  components: { Header }
})

export default class Venta extends FormsMixin {
  @Action("listarCategorias", { namespace: "ventas" }) listarCategorias!: Function;
  @Action("listarCategoriasArticulo", { namespace: "ventas" }) listarCategoriasArticulos!: Function;
  @Action("listarProveedores", { namespace: "Proveedores" }) listarProveedores!: Function;
  @Action("listarArticulos", { namespace: "ventas" }) listarArticulos!: Function;
  @Action("listarArticulosFiltrado", { namespace: "ventas" }) listarArticulosFiltrado!: Function;
  @Action("postActualizaFavorito", { namespace: "ventas" }) postActualizaFavorito!: Function;
  @State('isMobile') isMobile!: boolean;
  @Action("GetImageUrl", { namespace: "general" }) GetImageUrl!: Function;
  @Action("GetConfig", { namespace: "ventas" }) getConfig!: Function;


  public listadoCategorias: Array<CATEGORIAS> = [];
  public listadoCategoriasArticulos: Array<CATEGORIAS> = [];
  public listadoArticulos: Array<ARTICULO> = [];
  public listadoWeb: ARTICULO_WEB = {
    total: 0,
    lstArticulo: []

  }
  public cesta: Array<CESTA> = [];
  public DialogArticulos = false;
  public DialogCambioCliente = false;
  public EsCliente = false;
  public Favoritos = false;
  public search = "";
  public codpro = "";
  public codcat = "";
  public expand = "N";
  public imageUrl = "";
  public checkStock = false;
  public cliente: CLIENTES = {
    CODCLI: "",
    NOMCLI: "",
    AT_APP: "",
    AT_PASSWORD: "",
    CODREP: "",
    E_MAIL: "",
    NIFCLI: ""
  };
  public categoriaSeleccionada: CATEGORIAS = {
    AT_COD: "",
    AT_DESC: "",
    Imagen: ""
  };
  public categorias: CATEGORIAS[] = [];
  public proveedores: PROVEED[] = [];
  public currentPage = 1;
  public itemsPerPage = 10;
  public perPageValues = [5, 10, 15, 20];
  public total = 0;
  public stockConfig = true;

  async mounted() {
    this.$root.$emit("loading", true);
    this.cliente = JSON.parse(localStorage.getItem('CliePedido') || '{}');
    this.EsCliente = JSON.parse(localStorage.getItem('userLogged') || '{}').esCliente;

    const res = await this.getConfig();
    res == 'T' ? this.stockConfig = true : this.stockConfig = false;
    //@ts-ignore
    if (this.cliente == undefined || this.cliente.CODCLI == undefined) {
      this.$router.push("seleccionCliente");
    } else {
      this.listadoCategorias = await this.listarCategorias({ codcli: this.cliente.CODCLI });
      this.listadoCategoriasArticulos = await this.listarCategoriasArticulos({ codcli: this.cliente.CODCLI });
      this.$root.$on("devolverCesta", (cesta: Array<CESTA>) => { this.cesta = cesta });
      this.$root.$emit("solicitarCesta");
    }

    const urlParams = new URLSearchParams(window.location.search);

    if (urlParams.has("favoritos")) {
      this.Favoritos = true;
      this.categoriaSeleccionada = { AT_COD: "", AT_DESC: "", Imagen: "" };
      this.MuestraDialogArticulos(this.categoriaSeleccionada)
    }

    this.imageUrl = await this.GetImageUrl();

    this.$root.$emit("loading", false);
    window.scrollTo(0, 0);
  }

  toggleMostrarCesta() {
    this.$root.$emit("toggleShowCart");
  }

  onClickRow(cat: CATEGORIAS) {
    //
  }

  CerrarSession() {
    this.$root.$emit("cerrarSesion");
  }

  showButtons(item: any) {
    return item.children == null
  }

  AñadirACesta(item: ARTICULO) {
    this.$root.$emit("addToCart", item);
    if(item.CANTIDAD<0)item.CANTIDAD=0
    item.CANTIDAD++;
    item.CAJAS=Math.ceil(item.CANTIDAD/item.UNIPAQV)
  }

  AñadirACestav2(item: ARTICULO) {
    console.log(item);
    item.CAJAS=Math.ceil(item.CANTIDAD/item.UNIPAQV)
    this.$root.$emit("addToCartV2", item);
  }

  AñadirCaja(item: ARTICULO,qtt: number){
    if(item.CAJAS==0){
      item.CAJAS++
      item.CANTIDAD = item.UNIPAQV*item.CAJAS;
      this.$root.$emit("addToCart", item)
    }else{
      if (qtt != 0) {
        item.CAJAS += qtt;
      }
      item.CANTIDAD = item.UNIPAQV*item.CAJAS;
      if(item.CANTIDAD<=0)this.$root.$emit("RestCart", item);
      else this.$root.$emit("addToCartV2", item);
    }
    
  }
  

  //@ts-ignore
  validateInteger(event) {
    // Remove any non-integer characters
    console.log(event);
    let value = event.target.value;
    
    if (!Number.isInteger(Number(value))) {
      value = value.split('.')[0]; // Remove decimal part
      event.target.value = value;
      //this.number = value;
    }
  }
  

  RestarDeCesta(item: ARTICULO) {
    this.$root.$emit("RestCart", item);
    item.CANTIDAD--;
    item.CAJAS=Math.ceil(item.CANTIDAD/item.UNIPAQV)
  }

  async MuestraDialogArticulos(categoria: CATEGORIAS) {
    this.$root.$emit("loading", true);

    if(localStorage.getItem("check_stock")) this.checkStock = true;

    this.categoriaSeleccionada = categoria;
    this.codcat = categoria.AT_COD;
    this.listadoWeb = await this.listarArticulos({ favorito: this.Favoritos, codcategoria: this.categoriaSeleccionada.AT_COD, codcli: this.cliente.CODCLI, page: this.currentPage, items: this.itemsPerPage, checkStock: this.checkStock })

    this.listadoArticulos = this.listadoWeb?.lstArticulo;
    if(this.listadoArticulos == undefined) this.listadoArticulos = [];
    this.total = this.listadoWeb.total;

    if(this.listadoArticulos != null && this.listadoArticulos != undefined){
      this.listadoArticulos.forEach(art =>{
        art.CANTIDAD = this.getCantidadCesta(art.CODART);
        art.CAJAS = Math.ceil(art.CANTIDAD/art.UNIPAQV)
      })
    }
   

    this.proveedores = await this.listarProveedores({ codcat: this.codcat });

    this.$root.$emit("loading", false);
    this.DialogArticulos = true;
  }

  checkFilters(){
    if((this.codpro != "0" && this.codpro != "") || (this.codcat != "0" && this.codcat != "") || this.search!= "" || this.checkStock) return true;
    
    return false;
  }

  saveCheck(){
    if(this.checkStock){
      localStorage.setItem("check_stock", 'T');
    }
    else localStorage.removeItem("check_stock")
    
  }

  async paginar() {

    this.$root.$emit("loading", true);

    this.listadoWeb = await this.listarArticulosFiltrado({ favorito: this.Favoritos, codcategoria: this.categoriaSeleccionada.AT_COD, codcli: this.cliente.CODCLI, codpro: this.codpro, filtro: this.search, page: this.currentPage, items: this.itemsPerPage, checkStock: this.checkStock });

    this.listadoArticulos = this.listadoWeb?.lstArticulo;
    this.total = this.listadoWeb.total;

    if(this.listadoArticulos == undefined) this.listadoArticulos = [];

    if(this.listadoArticulos != null && this.listadoArticulos != undefined){
      this.listadoArticulos.forEach(art =>{
      art.CANTIDAD = this.getCantidadCesta(art.CODART);
    })
    }
    

    this.$root.$emit("loading", false);
  }

  async RefrescarListadoArticulos() {

    this.currentPage = 1;

    this.expand = "N";

    this.$root.$emit("loading", true);
    this.listadoWeb = await this.listarArticulosFiltrado({ favorito: this.Favoritos, codcategoria: this.codcat, codcli: this.cliente.CODCLI, codpro: this.codpro, filtro: this.search, page: this.currentPage, items: this.itemsPerPage, checkStock: this.checkStock });
    this.listadoArticulos = this.listadoWeb?.lstArticulo;
    this.total = this.listadoWeb.total;

    if(this.listadoArticulos == undefined) this.listadoArticulos = [];

    if(this.listadoArticulos != null && this.listadoArticulos != undefined){
      this.listadoArticulos.forEach(art =>{
        art.CANTIDAD = this.getCantidadCesta(art.CODART);
      })
    }
    

    this.proveedores = await this.listarProveedores();
    this.$root.$emit("loading", false);
  }

  async onChange(event: any) {

    this.$root.$emit("loading", true);
    this.currentPage = 1;
    this.categoriaSeleccionada.AT_COD = event;
    this.codcat = event

    this.listadoWeb = await this.listarArticulosFiltrado({ favorito: this.Favoritos, codcategoria: this.categoriaSeleccionada.AT_COD, codcli: this.cliente.CODCLI, codpro: this.codpro, filtro: this.search, page: this.currentPage, items: this.itemsPerPage });
    this.listadoArticulos = this.listadoWeb?.lstArticulo;
    this.total = this.listadoWeb.total;

    if(this.listadoArticulos == undefined) this.listadoArticulos = [];

    if(this.listadoArticulos != null && this.listadoArticulos != undefined){
    this.listadoArticulos.forEach(art =>{
      art.CANTIDAD = this.getCantidadCesta(art.CODART);
    })
  }

    this.proveedores = await this.listarProveedores({ codcat: this.codcat });
    this.$root.$emit("loading", false);
  }

  MostrarHistorico() {
    if (this.$router.currentRoute.name != "PedidoCompletados") this.$router.push({ name: "PedidoCompletados" });
  }

  //@ts-ignore
  changeItemsPage(event) {

    this.itemsPerPage = event;
    this.currentPage = 1;

    this.paginar();
  }

  CerrarListadoArticulos() {
    this.DialogArticulos = false;
    this.currentPage = 1;
    this.codcat = "";
    this.codpro = "";
    this.search = ""
    const url = window.location.href;
    if (url.includes("favoritos=true")) {
      console.log("cerrar");
      window.location.href = url.replace("?favoritos=true", "");
    }
  }

  getCantidadCesta(codart: string) {
    const existe = this.cesta.find(x => x.articulo.CODART == codart);
    if (existe != undefined) {

      return existe.cantidad
    } else { return 0; }
  }


  //@ts-ignore
  moreQuant(event, item: ARTICULO){

    if(Number(item.CANTIDAD) > item.STOCK){
      item.CANTIDAD = Number(item.CANTIDAD);
      this.$toast.error("La cantidad introducida no es correcta, supera el stock disponible.");
      item.CANTIDAD = item.STOCK;
      this.AñadirACestav2(item)
    }
    else{
      if(item.CANTIDAD == 0)
        this.$root.$emit("RestCart", item);
      else
        this.AñadirACestav2(item)
    }
  }

  HistoricoArticulos() {
    this.$router.push({ name: "Historico" });
  }

  MuestraDialogCambioCliente() {
    this.DialogCambioCliente = true;
  }

  OcultaDialogCambioCliente() {
    this.DialogCambioCliente = false;
  }

  VuelveSeleccionUsuario() {
    this.$root.$emit("quitarCliente")
    this.$router.push({ name: "SeleccionCliente" });
  }

  EsAccesoCliente() {
    return (this.EsCliente == false)
  }

  MostrarFacturas() {
    this.$root.$emit("mostrarFacturas");
  }

  async ActualizaFavorito(item: ARTICULO) {

    console.log(item);
    await this.postActualizaFavorito({
      favorito: !item.FAVORITO,
      codcli: this.cliente.CODCLI,
      codart: item.CODART
    })
    const index = this.listadoArticulos.indexOf(item)
    if (index > -1) {
      this.listadoArticulos[index].FAVORITO = !item.FAVORITO
    }
  }

  MostrarFavoritos() {
    if (this.$router.currentRoute.name != "venta") this.$router.push({ name: "venta", query: { favoritos: "true" } });
    else {
      this.Favoritos = true;
      this.codcat="";
      this.codpro = "";
      this.search="";
      this.MuestraDialogArticulos(this.categoriaSeleccionada)
    }
  }

  imageError(item: ARTICULO) {
    item.IMAGEN = this.imageUrl + "default.jpg";
  }

  MostrarPrincipal() {
    if (this.$router.currentRoute.name != "venta") this.$router.push({ name: "venta" });
    else {
      let url = window.location.href;
      if (url.indexOf('?') > -1) {
        url = url.replace("?favoritos=true", "");

      }
      this.DialogArticulos = false;
      window.location.href = url;
    }
  }

  AddCajaInicio(item: ARTICULO){
    if(item.UNIPAQV==1 )return false
    else if(item.UNIPAQV>1 && item.CANTIDAD==0) return true
    else if(item.UNIPAQV>1 && item.CANTIDAD>0) return true
  }

  AddUnidadInicio(item: ARTICULO){
    if(item.UNIPAQV==1 )return true
    else if(item.UNIPAQV>1 && item.CANTIDAD==0) return false
    else if(item.CANTIDAD>0) return true
  }
}